// thousand separator space function (i.e 7000 => 7 000)
export function numberWithSpace(number: number): string {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}